import _CampaignStatsBase from './_CampaignStatsBase';

export const CampaignEmbeddedEpisodeStats = ({campaign, campaignEpisode}) => {
  return <_CampaignStatsBase campaign={campaign} instance={campaignEpisode} />;
};
